/**
 * Empêche l'exécution de la fonction tant que la valeur de clé fournie est vrai
 */
export function PreventMultipleClick(loadingKey: string = 'isLoading'): MethodDecorator {
  return (_target: () => void, _propertyKey: string, descriptor: PropertyDescriptor) => {
    const original = descriptor.value;
    descriptor.value = function (...args: any[]) {
      if (
        (typeof this[loadingKey] === 'boolean' && !!this[loadingKey]) ||
        (typeof this[loadingKey] === 'function' && !!this[loadingKey]())
      ) {
        return;
      }

      return original.apply(this, args);
    };

    return descriptor;
  };
}
